import React, { useState } from "react";
import { FiBriefcase, FiFolder, FiCreditCard, FiDollarSign, FiAlignLeft, FiCode, FiCalendar, FiSave } from "react-icons/fi";
import { Field, FormAlert, SubmitButton } from "../forms/formKit";

const emptyJob = {
  title: "", description: "", category: "", budget_type: "fixed", budget_min: "", budget_max: "", skills: "", deadline: "",
};

// Create / edit a job. onSubmit(payload) resolves to an error string, or "" on success.
export default function JobForm({ settings, initial, onSubmit, onCancel }) {
  const [form, setForm] = useState(initial ? { ...emptyJob, ...initial } : emptyJob);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const categories = (settings?.categories || "").split("\n").map((c) => c.trim()).filter(Boolean);
  const currency = settings?.currency_label || "USD";
  const set = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const payload = {
      title: form.title, description: form.description, category: form.category, budget_type: form.budget_type,
      budget_min: form.budget_min === "" ? null : form.budget_min,
      budget_max: form.budget_max === "" ? null : form.budget_max,
      skills: form.skills, deadline: form.deadline || null,
    };
    const message = await onSubmit(payload);
    setBusy(false);
    if (message) setError(message);
  };

  return (
    <form onSubmit={submit} className="space-y-5">
      <Field label="Job title" required icon={FiBriefcase} maxLength={150} value={form.title} onChange={set("title")} placeholder="e.g. Build a responsive company website" />
      <div className="grid md:grid-cols-2 gap-5">
        <Field as="select" label="Category" icon={FiFolder} value={form.category} onChange={set("category")}>
          <option value="">Select a category</option>
          {categories.map((c) => <option key={c} value={c}>{c}</option>)}
        </Field>
        <Field as="select" label="Payment type" icon={FiCreditCard} value={form.budget_type} onChange={set("budget_type")}>
          <option value="fixed">Fixed price</option>
          <option value="hourly">Hourly rate</option>
        </Field>
      </div>
      <div className="grid grid-cols-2 gap-5">
        <Field label={`Budget from (${currency})`} icon={FiDollarSign} type="number" min="0" step="0.01" value={form.budget_min ?? ""} onChange={set("budget_min")} />
        <Field label={`Budget to (${currency})`} icon={FiDollarSign} type="number" min="0" step="0.01" value={form.budget_max ?? ""} onChange={set("budget_max")} />
      </div>
      <Field as="textarea" label="Description" required icon={FiAlignLeft} rows={6} value={form.description} onChange={set("description")} placeholder="Describe the work, deliverables and anything sellers should know..." />
      <div className="grid md:grid-cols-2 gap-5">
        <Field label="Skills" icon={FiCode} hint="Comma separated" value={form.skills} onChange={set("skills")} placeholder="React, Node.js, MySQL" />
        <Field label="Deadline" icon={FiCalendar} hint="Optional" type="date" value={form.deadline || ""} onChange={set("deadline")} />
      </div>
      <FormAlert>{error}</FormAlert>
      <div className="flex flex-wrap gap-3">
        <SubmitButton busy={busy} busyLabel="Saving..." icon={FiSave}>{initial ? "Save Changes" : "Post Job"}</SubmitButton>
        {onCancel && <button type="button" onClick={onCancel} className="px-6 py-2.5 rounded-full border border-navy-border text-gray-300 hover:text-white hover:border-accent-light transition-colors">Cancel</button>}
      </div>
    </form>
  );
}
